import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #fff5e6;
  border: 1px solid #ffe0b2;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff9500;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #ff9500;
  flex: 1;
`;

const NodeType = styled.div`
  font-size: 10px;
  background: rgba(255, 149, 0, 0.1);
  color: #ff9500;
  padding: 2px 6px;
  border-radius: 4px;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;

const NodeDetails = styled.div`
  font-size: 11px;
  color: #777;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailItem = styled.div`
  display: flex;
`;

const DetailLabel = styled.span`
  font-weight: 500;
  margin-right: 5px;
`;

const DetailValue = styled.span`
  color: #555;
`;

const ToolNode = ({ data }) => {
  const { label, description, toolType, endpoint, method } = data;
  
  const toolTypeLabels = {
    api: 'API',
    code: 'Code Execution',
    webhook: 'Webhook',
    function: 'Function'
  };
  
  const getToolIcon = (type) => {
    switch(type) {
      case 'api': return '⚒';
      case 'code': return '⌨';
      case 'webhook': return '⚡';
      case 'function': return '⚙';
      default: return '⚒';
    }
  };
  
  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />
      
      <NodeHeader>
        <NodeIcon>{getToolIcon(toolType)}</NodeIcon>
        <NodeLabel>{label}</NodeLabel>
        <NodeType>{toolTypeLabels[toolType] || 'Tool'}</NodeType>
      </NodeHeader>
      
      <NodeDescription>{description}</NodeDescription>
      
      <NodeDetails>
        {(toolType === 'api' || toolType === 'webhook') && endpoint && (
          <DetailItem>
            <DetailLabel>Endpoint:</DetailLabel>
            <DetailValue>{endpoint}</DetailValue>
          </DetailItem>
        )}
        
        {(toolType === 'api' || toolType === 'webhook') && method && (
          <DetailItem>
            <DetailLabel>Method:</DetailLabel>
            <DetailValue>{method}</DetailValue>
          </DetailItem>
        )}
        
        {toolType === 'code' && data.code && (
          <DetailItem>
            <DetailLabel>Code:</DetailLabel>
            <DetailValue>{data.code.length > 20 ? data.code.substring(0, 20) + '...' : data.code}</DetailValue>
          </DetailItem>
        )}
      </NodeDetails>
      
      <Handle type="source" position={Position.Bottom} />
    </NodeContainer>
  );
};

export default memo(ToolNode);
